import { Views } from 'react-big-calendar';
import { RestCountry, SelectData } from '../types/common';

// email validation regex declared here
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i;

export const USERNAME_REGEX = /^[a-zA-Z0-9_-]{3,}$/;

export const PHONE_NO_REGEX = /^\+?[1-9]\d{1,14}$/;

export const USERNAME_EMAIL_REGEX =
  /^(?:[a-zA-Z0-9_]{3,16}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\]\\/~`+=_;'-]).{8,}$/;
export const LINKEDIN_PROFILE_REGEX =
  /^https?:\/\/(www\.)?linkedin\.com\/(in|pub|profile|company|school)\/[a-zA-Z0-9-]+\/?$/;

export const TIMESTAMP_REGEX =
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}\+\d{2}:\d{2}/;

// regex to validate string with no whitespace in front declared here
export const VALID_STRING_REGEX = /^\S/;

// regex for finding uppercase letter in a string declared here
export const UPPERCASE_REGEX = /([A-Z])/g;

// stream constrains for video conferencing declared here
export const VIDEO_STREAM_CONSTRAINS = {
  video: {
    width: { min: 640, ideal: 1920, max: 1920 },
    height: { min: 480, ideal: 1080, max: 1080 },
  },
};

// view options for calender declared here
export const CALENDAR_VIEW_OPTIONS = [
  { id: Views.MONTH, label: 'Month', color: '#388229' },
  { id: Views.WEEK, label: 'Week', color: '#00BCEF' },
  { id: Views.DAY, label: 'Day', color: '#845ADF' },
];

// filter options for calender declared here
export const CHART_FILTER_OPTIONS = [
  { id: 1, label: 'This Year', color: '#388229' },
  { id: 2, label: 'This Month', color: '#00BCEF' },
  { id: 3, label: 'Today', color: '#845ADF' },
];

// filter options for appointment declared here
export const APPOINTMENT_FILTER_OPTIONS_CLIENT = [
  'All',
  'Referrals',
  'Running',
  'Upcoming',
  'Completed',
  'Unattended',
];

// filter options for appointment declared here
export const APPOINTMENT_FILTER_OPTIONS_ADMIN = [
  'All',
  'Running',
  'Upcoming',
  'Completed',
  'Unattended',
];

export const RESCHEDULE_HISTORY_FILTER_OPTIONS = [
  { id: 'to', label: 'Assigned To', color: '#845ADF' },
  { id: 'by', label: 'Assigned By', color: '#00BCEF' },
];

export const REFERRAL_HISTORY_FILTER_OPTIONS = [
  { id: 'to', label: 'Referred To', color: '#845ADF' },
  { id: 'by', label: 'Referred By', color: '#00BCEF' },
];

export const TRANSACTION_HISTORY_FILTER_OPTIONS = [
  { id: 'gateway', label: 'Gateway', color: '#845ADF' },
  { id: 'manual', label: 'Manual', color: '#00BCEF' },
];

// select field default value declared here
export const SELECT_FIELD_DEFAULT_VALUE = {
  id: -1,
  name: '--Select--',
};

export const TABLE_ROW_NUMBER_OPTIONS = ['10', '15', '20', '30', '50'];

export const PAYMENT_METHOD_OPTIONS = [
  { id: 1, name: 'Stripe' },
  { id: 2, name: 'PayPal' },
  { id: 3, name: 'G Pay' },
];

export const ASSOCIATE_FORM_COUNT_CREATE = 3;
export const ASSOCIATE_FORM_COUNT_UPDATE = 2;

export const ASSOCIATE_EXPERTISE_OPTIONS = [
  { id: 1, name: 'beginner' },
  { id: 2, name: 'intermediate' },
  { id: 3, name: 'advanced' },
  { id: 4, name: 'expert' },
];

export const TIME_PERIOD_OPTIONS = [
  { id: -1, name: '--Select--' },
  { id: 1, name: 'Morning' },
  { id: 2, name: 'Noon' },
  { id: 3, name: 'Evening' },
];

export const TIME_PERIOD_DESCRIPTIONS = [
  '',
  '(5:00 AM - 11:59 AM)',
  '(12:00 PM - 5:59 PM)',
  '(6:00 PM - 10:00 PM)',
];

export const TIME_PICKER_HOURS = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
];

export const TIME_PICKER_MINUTES = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '60',
];

export const TIME_PICKER_MERIDIANS = ['AM', 'PM'];

export const GRID_VIEW_TIME_SLOTS = [
  { start_time: 5, end_time: 7 },
  { start_time: 8, end_time: 10 },
  { start_time: 11, end_time: 13 },
  { start_time: 14, end_time: 16 },
  { start_time: 17, end_time: 19 },
  { start_time: 20, end_time: 23 },
];

export const GRID_TIME_SLOT_DEFAULT_VALUE = [
  false,
  false,
  false,
  false,
  false,
  false,
];

// table span classes declared here
export const TABLE_HEAD_SPAN_CLASSES =
  'inline-block min-w-[250px] lg:min-w-[200px] capitalize';

export const TABLE_BODY_SPAN_CLASSES = 'block w-full truncate';

// settings for image compression declared here
export const MAX_WIDTH = 200;
export const MAX_HEIGHT = 100;
export const MIME_TYPE = 'image/jpeg';
export const QUALITY = 1;

// number of appointment cards showed in a page declared here
export const APPOINTMENT_CARDS_PER_PAGE = 8;

export const DEFAULT_REST_COUNTRY_SELECT_VALUE: RestCountry = {
  cca2: '',
  idd: {
    root: '+1',
    suffixes: [''],
  },
  name: {
    common: '--Select--',
    nativeName: {},
    official: '--Select--',
  },
};

export const DEFAULT_PASSWORD_RESTRICTION_RULES = [
  {
    restriction_text: 'Must be 8 characters long',
    restriction_reg_ex: /^.{8,}$/,
  },
  {
    restriction_text: 'must contain at least an uppercase character',
    restriction_reg_ex: /[A-Z]/,
  },
  {
    restriction_text: 'must contain at least a lowercase character',
    restriction_reg_ex: /[a-z]/,
  },
  {
    restriction_text: 'Must contain at least one special Character',
    restriction_reg_ex: /[!@#$%^&*(),.?":{}|<>[\]\\/~`+=_;'-]/,
  },
  {
    restriction_text: 'Must contain at least one number',
    restriction_reg_ex: /[0-9]/,
  },
];

export const DEFAULT_TIME_PERIOD = {
  slot_start_time: '',
  slot_end_time: '',
};

export const REQUIRED_DOC_LIST = [
  {
    doc_title: 'Law Degree Transcript',
    doc_description:
      'Official transcript from an accredited Canadian law school showing completion Juris Doctor (JD) or Bachelor of Laws (LLB) program.',
  },

  {
    doc_title: 'Certificate of Qualification (if applicable)',
    doc_description:
      'If you are a foreign-trained lawyer, you will need a Certificate of Qualification from the National Committee on Accreditation (NCA) demonstrating your legal education is equivalent to a Canadian law degree.',
  },

  {
    doc_title: 'Proof of Identity',
    doc_description: `Government-issued photo identification like a passport or driver's license.`,
  },

  {
    doc_title: 'Good Character Documentation',
    doc_description:
      'May include references, background checks, and a completed questionnaire regarding your character and fitness to practice law.',
  },

  {
    doc_title: 'Bar Exam Results',
    doc_description:
      'Successful completion of the required bar exams for your chosen jurisdiction.',
  },

  {
    doc_title: 'Articling Completion Certificate',
    doc_description:
      'Proof of completing the required articling period under a supervising lawyer.',
  },

  {
    doc_title: 'Any Additional Documents (if required)',
    doc_description:
      'Also any additional documents you think you need to show to the Admin.',
  },
];

export const REQUIRED_DOC_NAMES: Array<SelectData> = [
  { id: 1, name: 'Law Degree Transcript' },
  { id: 2, name: 'Proof of Identity' },
  { id: 3, name: 'Good Character Documentation' },
  { id: 4, name: 'Bar Exam Results' },
  { id: 5, name: 'Articling Completion Certificate' },
  { id: 6, name: 'Certificate of Qualification' },
];

export const MINIMUM_LEGAL_AGE = 15;

export const APPLICATION_FORM_STAGES = [
  'profile',
  'contact',
  'professional',
  'documents',
];
